var SocketService = (function () {
    function SocketService(socketFactory, $localStorage, socket) {
        this.socketFactory = socketFactory;
        this.$localStorage = $localStorage;
        this.socket = socket;
        var self = this;
        this.start = new Date().getTime();
        this.socket = io.connect('/', {
            forceNew: false,
            timeout: SocketService.CLINET_SOCKET_IO_PING_TIMEOUT,
            transports: ['websocket'],
            upgrade: false
        });
        this.socket.on('connect', onConnect);
        this.socket.on('disconnect', onDisconnect);
        this.socket.on('error', onError);
        var mySocket = socketFactory({
            ioSocket: this.socket
        });
        return mySocket;
        function onConnect(data) {
            console.info("$scoket (onConnect) => socket connected at " + (new Date().getTime() - self.start) + " ms");
            if (!('Notification' in window)) {
                console.info('$scoket (onConnect) => Web Notification not supported');
                return;
            }
            var not = self.$localStorage.notification;
            if (not) {
                console.info('$scoket (onConnect) => notifications enabled');
                return notif();
            }
            Notification.requestPermission(function (permission) {
                if (permission === 'granted') {
                    notif();
                    self.$localStorage.notification = true;
                    console.info('notifications saved');
                }
            });
        }
        function notif() {
            var _this = this;
            this.notification = new Notification('DMT', {
                body: 'You are now connected to DMT',
                icon: '/static/img/io-lab-green.png',
                dir: 'auto'
            });
            return setTimeout(function () {
                _this.notification.close();
            }, 3000);
        }
        function onDisconnect(data) {
            console.error("Socket Disconnected " + (new Date().getTime() - self.start) + " ms");
        }
        function onError(data) {
            console.error("Socket Error " + (new Date().getTime() - self.start) + " ms", data);
        }
    }
    SocketService.$inject = ['socketFactory', '$localStorage'];
    SocketService.CLINET_SOCKET_IO_PING_TIMEOUT = 40000; // 20000 by default
    return SocketService;
}());
angular
    .module('application')
    .factory('socket', SocketService);

//# sourceMappingURL=socket.js.map
